export class MotivoTransicaoAtivoRequest {
    public isAtivo: boolean;
}
